import React from "react";

import ShareButtonWrapper from "./shareButtonWrapper";
import { ReactComponent as FacebookIcon } from "../../../semantic/assets/images/share/facebook.svg";

const FacebookShare = (props) => {
  const text = props.text ? props.text : "";
  const classNames = props.classNames ? props.classNames : "";
  const url = `https://facebook.com/sharer/sharer.php?u=${props.url}`;

  return (
    <ShareButtonWrapper url={url} onClick={props.onClick}>
      <div className={classNames}>
        {props.children}
        {!props.children && (
          <div>
            <FacebookIcon />
            {text}
          </div>
        )}
      </div>
    </ShareButtonWrapper>
  );
};

export default FacebookShare;
